import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupMasterService {

  constructor(private http: HttpClient, private httpService: HttpService) {

  }

  getGroupList() {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'group/',{headers:headers})
          .map(res => res);

          // var request = {
          //     URL : "group/"
          // }
          // return this.httpService.get(request); 
  }

 

  addGroup(newGroup) {
      // var headers =this.httpService.addHeaders();
      // // headers.append('Content-Type', 'application/json');
      // return this.http.post(environment.pssUrl + 'group/', JSON.stringify(newGroup), { headers: headers })
      //     .map(res => res.json());

      var request = {
          URL : 'group',
          DATA: newGroup
      }
      return this.httpService.post(request);
    
  }

  getGroupById(groupId: string) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'group/' + groupId,{headers:headers})
          .map(res => res);

  }

  deleteGroup(groupId) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.get(environment.pssServerUrl + 'group/delete/' + groupId, { headers: headers })
          .map(res => res);
  }

  updateGroup(updatedGroup) {
    const token = localStorage.getItem('token') || '';
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': token
    });
  
    return this.http.post<any>(
      `${environment.pssServerUrl}group/${updatedGroup.GroupId}`,
      updatedGroup,
      { headers }
    );
  }



}